import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import PasswordVerificationModal from '../components/PasswordVerificationModal';
import { authService } from '../services/authService';
import FileExplorer from '../components/FileExplorer';
import { useHRAccess } from '../hooks/useHRAccess';
import { hasCapability, CAP } from '../utils/permissions';

const EmployeeDocumentsPage: React.FC = () => {
  const { user } = useAuth();
  const isHrAdmin = hasCapability(user, CAP.HR_ADMIN_ACTIONS);
  const [passwordVerificationOpen, setPasswordVerificationOpen] = useState(false);
  const { isVerified: passwordVerified, grantAccess } = useHRAccess();

  useEffect(() => {
    if (isHrAdmin && !passwordVerified) {
      setPasswordVerificationOpen(true);
    }
  }, [isHrAdmin, passwordVerified]);

  const handlePasswordVerification = async (password: string) => {
    try {
      const response = await authService.verifyPassword(password);
      return response.data.verified;
    } catch {
      return false;
    }
  };

  const handlePasswordVerified = () => {
    grantAccess();
    setPasswordVerificationOpen(false);
  };

  if (isHrAdmin && !passwordVerified) {
    return (
      <PasswordVerificationModal
        open={passwordVerificationOpen}
        onClose={() => setPasswordVerificationOpen(false)}
        onVerify={handlePasswordVerification}
        onVerified={handlePasswordVerified}
        title="Access My Documents"
        description="Please verify your password to browse employee personal folders."
      />
    );
  }

  return (
    <Box>
      <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 3 }}>
        My Documents
      </Typography>
      <FileExplorer isHrAdmin={isHrAdmin} />
    </Box>
  );
};

export default EmployeeDocumentsPage;
